module.exports = __webpack_public_path__ + "media/images/undraw/reserve/data_trends-88d91cb336a381ab303ddfddf1954fd5.png";